import {
    FETCH_PACE_PRO_ALGORITHM_CONFIG,
    FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS,
    FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL
} from 'actions/paceProBandActions.js';

const INITIAL_STATE = {
    elevationSegmentationTolerance: 12,
    paceFactor: 2
};

const fetchPaceProAlgorithmConfigSuccess = (state, action) => {
    return action.config;
};

const fetchPaceProAlgorithmConfigFail = (state, action) => {
    return state;
};

const handlers = {
    [FETCH_PACE_PRO_ALGORITHM_CONFIG_SUCCESS]: fetchPaceProAlgorithmConfigSuccess,
    [FETCH_PACE_PRO_ALGORITHM_CONFIG_FAIL]: fetchPaceProAlgorithmConfigFail
};

export default function paceProBand(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchPaceProAlgorithmConfig(evictCache) {
    return {
        type: FETCH_PACE_PRO_ALGORITHM_CONFIG,
        meta: {
            cacheTime: evictCache ? null : 3600000 // 1 hour
        }
    };
}

// Getters
export const getPaceProAlgorithmConfig = (state) => {
    return state.paceProAlgorithmConfig;
};
